export const Dashboard_GET_REQUEST = "Dashboard_GET_REQUEST";
export const Dashboard_GET_SUCCESS = "Dashboard_GET_SUCCESS";
export const Dashboard_GET_FAIL = "Dashboard_GET_FAIL";
export const Dashboard_GET_RESET = "Dashboard_GET_RESET";
